__webpack_require__.p = "https://caracalui.beta.eu-west-1.urc.advertising.amazon.dev/";